module.exports = __webpack_public_path__ + "img/heart4.fffdff16.png";